var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8861 34.3169C33.0091 46.4229 7.71738 47.6728 1.97738 36.2498C-3.76262 24.8268 9.99124 0.670896 22.6082 0.0498959C35.2252 -0.636104 46.7631 22.2109 39.8861 34.3169Z",
    fill: "#FCD118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.726 43.8759C20.112 46.2299 8.82601 44.0498 5.22601 36.8868C2.05501 30.5768 4.24803 21.2949 9.49603 13.3269",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9136 18.2659C45.7016 24.1219 45.7653 30.3238 43.1353 34.9548C40.9953 38.7208 37.0756 41.4359 32.5156 43.0459",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4277 4.38391C36.4278 5.30291 37.3449 6.3085 38.168 7.38892",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6719 11.5449C14.8719 5.51393 20.4719 0.950846 25.8599 0.683846C27.6235 0.61087 29.3834 0.901792 31.0298 1.53834C32.6762 2.17488 34.1738 3.1435 35.4297 4.38392",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9648 18.2769L22.439 30.6058L49.0581 5.0719",
    stroke: "#231F20",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckYellow);
export default __webpack_public_path__ + "static/media/icon-check-yellow.208931842ac7c1d0911c97609a9c7a16.svg";
export { ForwardRef as ReactComponent };